export default {
  title: 'Creating item',
  title_edit: 'Editing item',
  'sections.basicInfo': 'Basic information',
  'sections.controlInfo': 'Control data',
  'sections.stockInfo': 'Stock information',
  'sections.buyInfo': 'Purchase information',
  'sections.sellInfo': 'Sales information',
  'sections.othersInfo': 'Other information',
  'fields.name': 'Name',
  'fields.code': 'Product code',
  'fields.subCategory': 'Subcategory',
  'fields.brand': 'Brand',
  'fields.model': 'Model',
  'fields.supplier': 'Supplier',
  'fields.sizeUnit': 'Unit of measure',
  'fields.description': 'Description',
  'fields.enabled': 'Active',
  'fields.amount': 'Stock quantity',
  'fields.minAmount': 'Minimum stock',
  'fields.maxAmount': 'Maximum stock',
  'fields.criticalAmount': 'Critical volume',
  'fields.warningAmount': 'Warning volume',
  'fields.notificationEmails': 'Alert emails',
  'fields.purchasePrice': 'Cost price',
  'fields.purchaseTax': 'Taxes',
  'fields.currency': 'Currency',
  'fields.salesPrice': 'Sales price',
  'fields.maxDiscount': 'Maximum discount allowed',
  'fields.salesTax': 'Sales taxes',
  'fields.barCode': 'Barcode',
  'fields.notes': 'Notes',
  'fields.images': 'Images',
  'fields.addFile': 'Add File',
  'validation.required': 'Required field',
  'validation.amountGreaterThanZero': 'Amount must be greater than zero',
  'validation.invalidEmails': 'One or more invalid emails',
  'validation.duplicateEmails': 'One or more duplicate emails',
  'bulkTransfer.title': 'Transfers',
  'bulkTransfer.fields.status': 'Status',
  'bulkTransfer.fields.item': 'Item',
  'bulkTransfer.fields.operation': 'Operation',
  'bulkTransfer.fields.user': 'User',
  'bulkTransfer.fields.place': 'Place',
  'bulkTransfer.fields.amount': 'Amount',
  'bulkTransfer.validation.required': 'Required field',
  'bulkTransfer.validation.amountNotNegative': 'Amount cannot be less than zero',
  'bulkTransfer.validation.amountGreaterThanZero': 'Amount must be greater than zero',
  'bulkTransfer.actions.execute': 'Execute',
  'bulkTransfer.actions.close': 'Close',
  'statusTag.pending': 'Pending',
  'statusTag.success': 'Success',
  'statusTag.error': 'Error',
  'statusTag.insufficientAmount': 'Insufficient amount',
  'statusTag.amountGreaterThanZero': 'Amount must be greater than zero',
  'statusTag.genericError': 'Generic error',
  'tooltip.item': 'Item',
  'tooltip.amount': 'Amount',
  'tooltip.operation': 'Operation',
  'tooltip.error': 'Error'
}
